import React, { useContext } from 'react';
import styled from 'styled-components';
// import BilheteRosa from '../../assets/bilhete2.png';
import { URLContext } from '../../contexts/URLContext';

const BilheteContainer = styled.div`
  text-align: center;
`;

const Bilhete = (props) => {
  const {baseURL, campaignData} = useContext(URLContext);

  return (
    <BilheteContainer>
      {props.numTickets > 0 ? (
        <img
          src={`${baseURL}${campaignData.imgTicket}`}
          alt="Toque para abrir"
          onClick={props.rescue}
          style={{ maxWidth: 260 }}
        />
      ) : (
        <img
          src={`${baseURL}${campaignData.imgTicket}`}
          alt="Você não possui bilhetes"
          style={{ filter: "grayscale(100%)", opacity: 0.35, maxWidth: 260 }}
        />
      )}
    </BilheteContainer>
  )
};

export default Bilhete;